import { render, staticRenderFns } from "./ContractorTelegramCampaignModal.vue?vue&type=template&id=1a51d106"
import script from "./ContractorTelegramCampaignModal.vue?vue&type=script&lang=js"
export * from "./ContractorTelegramCampaignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports